export * from '../governamental/list/governamentalList.component';
export * from '../governamental/create/governamentalCreate.component';
export * from '../governamental/edit/governamentalEdit.component';
export * from '../governamental/detail/governamentalDetail.component';
export * from '../governamental/search/governamentalSearch.component';